import { AbstractControl, ValidatorFn } from '@angular/forms';

export function ValidateEnumField(allowedValues: string[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const value = control.value;
    if (!value || value.trim() === '') {
      return { required: true };
    }
    if (!allowedValues.includes(value)) {
      return { invalidValue: true };
    }
    return null;
  };
}
